import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CustomEmptyComponent from "../../../components/CustomEmptyComponent";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { availableOnlySuperAdminAndAdmin } from "utils/validation";

interface IStudentSubsidyDisabledComponent {
  schoolId: string;
}

const useStyles = makeStyles({
  accordionLabel: {
    marginTop: "5px",
  },
  MuiAccordionSummary: {
    "& .MuiAccordionSummary-content": {
      margin: "15px 0px 5px",
    },
  },
});

const StudentSubsidyDisabledComponent = ({
  schoolId,
}: IStudentSubsidyDisabledComponent) => {
  const classes = useStyles();

  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="cca-student-schedule-content"
        id="student-subsidy-header"
        className={classes.MuiAccordionSummary}
      >
        <h3 className={classes.accordionLabel}>Student Subsidy</h3>
      </AccordionSummary>
      <AccordionDetails>
        <CustomEmptyComponent
          resource="studentSubsidies"
          title="The student subsidy setting is disabled"
          caption="Please enable the student subsidy setting in the school setting summary to show the student subsidy table."
          url={`/schools/${schoolId}/show`}
          buttonLabel="Go to School Setting"
          buttonIcon={<KeyboardBackspaceIcon />}
          hasCreate={availableOnlySuperAdminAndAdmin()}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default StudentSubsidyDisabledComponent;
